import { defineComponent, PropType } from "vue";

import { COMPONENT_NAME } from "./attributes";

export default defineComponent({
  name: COMPONENT_NAME,
  props: {
    icon: { type: String, default: "" },
    title: { type: String, required: true },
    text: { type: String, default: "" },
    score: { type: Number as PropType<number | null>, default: null },
    passed: { type: Boolean, default: false },
    buttonLabel: { type: String, default: "" },
    buttonDisabled: { type: Boolean, default: false },
  },
  emits: ["action"],
});
